import { Link, useLocation } from "react-router-dom";

const TABS = [
  { to: "/admin", label: "Dashboard", testid: "nav-admin-dashboard", exact: true },
  { to: "/admin/posts", label: "Blog", testid: "nav-admin-posts" },
  { to: "/admin/deliveries", label: "Übergaben", testid: "nav-admin-deliveries" },
  { to: "/admin/testimonials", label: "Rezensionen", testid: "nav-admin-testimonials" },
  { to: "/admin/logos", label: "Logos", testid: "nav-admin-logos" },
  { to: "/admin/reels", label: "Reels", testid: "nav-admin-reels" },
];

export default function AdminNav({ active }) {
  const location = useLocation();
  return (
    <nav className="admin-tabs" data-testid="admin-tabs">
      {TABS.map((t) => {
        const isActive =
          active === t.to ||
          (t.exact ? location.pathname === t.to : location.pathname.startsWith(t.to));
        return (
          <Link
            key={t.to}
            to={t.to}
            className={`admin-tab${isActive ? " admin-tab--active" : ""}`}
            data-testid={t.testid}
          >
            {t.label}
          </Link>
        );
      })}
    </nav>
  );
}
